import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { theme, colors } from "../../theme/theme";

const AdminContentCard = ({ item }) => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() =>
        navigate(`/admin/posts/edit-post`, {
          state: { postId: item?.id },
        })
      }
      sx={{
        borderRadius: "14px",
        overflow: "hidden",
        border: theme.lightBorder,
        cursor: "pointer",
        backgroundColor: "rgba(255,255,255,0.03)",
        transition: "border-color 0.2s ease",
        "&:hover": {
          border: `1px solid ${colors.secondary}`,
        },
      }}
    >
      <Box
        component="img"
        src={item?.images?.[0]?.image_url}
        alt={item?.title}
        sx={{
          width: "100%",
          height: "160px",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Box sx={{ p: 2 }}>
        <Typography
          sx={{
            color: "#fff",
            fontFamily: "Mulish-SemiBold",
            fontSize: "16px",
            mb: 0.5,
          }}
        >
          {item?.title}
        </Typography>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontFamily: "Mulish-Regular",
            fontSize: "13px",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {item?.content}
        </Typography>
      </Box>
    </Box>
  );
};

export default AdminContentCard;
